export const getComponentMargin = (margin = false) => (margin ? 'tw-mb-14 lg:tw-mb-20' : '');

export const getComponentOutlineMargin = (outlineMargin = false) =>
  outlineMargin ? 'tw-p-4 lg:tw-px-8 lg:tw-py-0' : '';

export const getComponentViewportMargins = (margin = false, mobileMargin = false) => {
  const desktopMargins = 'lg:tw-mb-20';
  const mobileMargins = 'tw-mb-14';

  let margins = '';
  if (mobileMargin) margins += `${mobileMargins} ${desktopMargins ? 'lg:tw-mb-0' : ''} `;
  if (margin) margins += `${desktopMargins} `;

  return margins;
};

export const getAnchorId = (anchorID = '') => (anchorID ? { id: anchorID } : {});

export const getRichTextLines = (content: string) => content.match(/<[^]+?>.+?<\/[^]+?>/g) || [];

export const isRichTextEmpty = (content?: string): boolean =>
  !content ||
  content.length === 0 ||
  content === ' ' ||
  content === '&nbsp;' ||
  content === '' ||
  content === '<p><br /></p>' ||
  content === '<p><br /></p>\n' ||
  content === '<p><br /></p>' ||
  content === '<p><br></p>';

export const clearHTMLTags = strToSanitize => strToSanitize.replace(/(<([^>]+)>)/gi, '');

export const formatRichText = (content: string) =>
  content
    .replace(/<p><br><\/p>/g, '')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');

export const resetCtaWidth = (buttonRefs: any, width: string) => {
  if (!buttonRefs || buttonRefs.current.length === 0) return;
  buttonRefs.current.forEach(button => {
    button.style.width = width;
  });
};

export const getCtaMaxWidth = (buttonRefs: any) => {
  if (!buttonRefs || buttonRefs.current.length === 0) return;
  let maxWidth = buttonRefs.current[0].offsetWidth || 0;
  buttonRefs.current.forEach(button => {
    if (button.offsetWidth > maxWidth) {
      maxWidth = button.offsetWidth;
    }
  });
  return maxWidth;
};

export const setCtaSameWidth = (buttonRefs: any, maxWidth: number) => {
  if (!buttonRefs || buttonRefs.current.length === 0) return;
  buttonRefs.current.forEach(button => {
    button.style.width = `${maxWidth + 1}px`;
  });
};

export const resetRefsHeight = (refs: any, height: string) => {
  if (!refs || refs.current.length === 0) return;
  refs.current.forEach(button => {
    button.style.height = height;
  });
};

export const getRefsMaxHeight = (refs: any) => {
  if (!refs || refs.current.length === 0) return 0;
  let maxHeight = refs.current[0].offsetHeight || 0;
  refs.current.forEach(button => {
    if (button.offsetHeight > maxHeight) {
      maxHeight = button.offsetHeight;
    }
  });
  return maxHeight;
};

export const setRefsSameHeight = (refs: any, maxHeight: number) => {
  if (!refs || refs.current.length === 0) return;
  refs.current.forEach(button => {
    button.style.height = `${maxHeight + 1}px`;
  });
};
